"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var Tag =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Tag, _PureComponent);

  function Tag() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Tag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Tag)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function () {
      _this.props.onRemoveClick && _this.props.onRemoveClick(_this.props.value);
    });
    return _this;
  }

  (0, _createClass2["default"])(Tag, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          value = _this$props.value,
          removable = _this$props.removable,
          onRemoveClick = _this$props.onRemoveClick,
          className = _this$props.className,
          size = _this$props.size,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["label", "value", "removable", "onRemoveClick", "className", "size"]); // eslint-disable-line no-unused-vars

      return _react["default"].createElement("span", (0, _extends2["default"])({
        className: (0, _emotion.cx)('tag', (0, _defineProperty2["default"])({}, "label-".concat(size), size), className)
      }, rest), label !== undefined ? label : value, removable ? _react["default"].createElement("button", {
        className: "close",
        onClick: this.handleClick
      }, "x") : null);
    }
  }]);
  return Tag;
}(_react.PureComponent);

exports["default"] = Tag;
Tag.propTypes = {
  removable: _propTypes["default"].bool,
  onRemoveClick: _propTypes["default"].func,
  label: _propTypes["default"].node,
  value: _propTypes["default"].node,
  size: _propTypes["default"].oneOf(['sm', 'lg']),
  className: _propTypes["default"].string
};
Tag.defaultProps = {
  removable: false
};